import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { CellFunction } from '../../cells';
import { IEpxWellness } from '../../../../../libs/apps/epxwellness';

export const DataACell: CellFunction<IEpxWellness> = ({
  row: { original: session }
}) => {
  if (session.module === '_weight') {
    if (session._weight.weight) {
      return (
        <div>
          <span>
            Weight: <b>{session._weight.weight}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Weight: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_diet') {
    if (session._diet.vegMeals) {
      return (
        <div>
          <span>
            Meals w/ Veggies: <b>{session._diet.vegMeals}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Meals w/ Veggies: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_exercise') {
    if (session._exercise.activeMinutes) {
      return (
        <div>
          <span>
            Active Mins: <b>{session._exercise.activeMinutes}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Active Mins: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_diabetes') {
    if (session._diabetes.bloodSugar) {
      return (
        <div>
          <span>
            Blood Sugar: <b>{session._diabetes.bloodSugar}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Blood Sugar: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_hypertension') {
    if (session._hypertension.upper) {
      return (
        <div>
          <span>
            Upper: <b>{session._hypertension.upper}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Upper: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else {
    return null;
  }
};

export const DataBCell: CellFunction<IEpxWellness> = ({
  row: { original: session }
}) => {
  if (session.module === '_weight') {
    if (session._weight.didReachGoal) {
      return (
        <div>
          <span>
            Reached Goal: <b>{session._weight.didReachGoal ? 'Yes' : 'No'}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Reached Goal: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_diet') {
    if (session._diet.isInRange) {
      return (
        <div>
          <span>
            Reached Goal: <b>{session._diet.isInRange ? 'Yes' : 'No'}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Reached Goal: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_exercise') {
    if (session._exercise.isInRange) {
      return (
        <div>
          <span>
            Reached Goal: <b>{session._exercise.isInRange ? 'Yes' : 'No'}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Reached Goal: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_diabetes') {
    if (session._diabetes.hasEaten) {
      return (
        <div>
          <span>
            Has Eaten: <b>{session._diabetes.hasEaten ? 'Yes' : 'No'}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Has Eaten: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_hypertension') {
    if (session._hypertension.lower) {
      return (
        <div>
          <span>
            Lower: <b>{session._hypertension.lower}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            Lower: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else {
    return null;
  }
};

export const DataCCell: CellFunction<IEpxWellness> = ({
  row: { original: session }
}) => {
  if (session.module === '_weight') {
    if (session._weight.weightLossGoal) {
      return (
        <div>
          <span>
            New Goal: <b>{session._weight.weightLossGoal}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            New Goal: <b>-</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_diet') {
    if (session._diet.vegMealGoal) {
      return (
        <div>
          <span>
            New Goal: <b>{session._diet.vegMealGoal}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            New Goal: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_exercise') {
    if (session._exercise.activeMinutesGoal) {
      return (
        <div>
          <span>
            New Goal: <b>{session._exercise.activeMinutesGoal}</b>
            <br />
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span>
            New Goal: <b>?</b>
            <br />
          </span>
        </div>
      );
    }
  } else if (session.module === '_diabetes') {
    return <span>-</span>;
  } else if (session.module === '_hypertension') {
    return <span>-</span>;
  } else {
    return null;
  }
};

const EpxWellnessTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxWellness>[] = [
    {
      Header: 'Data A',
      id: '_dataA',
      Cell: ResponseGuard(DataACell)
    },
    {
      Header: 'Data B',
      id: '_dataB',
      Cell: ResponseGuard(DataBCell)
    },
    {
      Header: 'Data C',
      id: '_dataC',
      Cell: ResponseGuard(DataCCell)
    }
  ];
  return (
    <SessionTable<IEpxWellness>
      url="/epxwellness/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxWellnessTable;
